import { axiosInstance } from "@/api/axios";
import { AxiosRequestConfig } from "axios";
import { CreateUserFormValues } from "@/types/user";
import { UpdateUserFormValues } from "@/types/user";
import { ChangePasswordFormValues } from "@/types/user";

export const getUsers = async (config?: AxiosRequestConfig) => {
  if (config?.params?.sort) {
    config.params.sort = JSON.stringify(config.params.sort);
  }

  if (config?.params?.filters) {
    config.params.filters = JSON.stringify(config.params.filters);
  }

  const { data } = await axiosInstance.get("/users", config);
  return data;
};

export const createUser = async (data: CreateUserFormValues) => {
  const response = await axiosInstance.post("/users", data);
  return response.data;
};

export const updateUser = async (id: string, data: UpdateUserFormValues) => {
  const response = await axiosInstance.put(`/users/${id}`, data);
  return response.data;
};

export const deleteUser = async (id: string) => {
  const response = await axiosInstance.delete(`/users/${id}`);
  return response.data;
};

export const changeUserPassword = async (
  id: string,
  data: ChangePasswordFormValues
) => {
  const response = await axiosInstance.patch(
    `/users/${id}/change-password`,
    data
  );
  return response.data;
};

export const getRoles = async (config?: AxiosRequestConfig) => {
  const response = await axiosInstance.get("/roles", config);
  return response.data;
};
